import React, { Component } from 'react'
import { gql, graphql } from 'react-apollo'
import t from 'prop-types'

import {
  Grid,
  Form,
  Notifications,
} from 'components/UI'
import UserOrganizationList from './UserOrganizationList'
import UserBuildingList from './UserBuildingList'

class AdminUserCreate extends Component {
  state = {
    organizationId: null,
    email: '',
    mutationError: false,
  }

  handleOrgSelect = organizationId => {
    this.setState({
      organizationId,
    })
  }

  handleEmailChange = email => {
    this.setState({ email })
  }

  handleSubmit = () => {
    const {
      organizationId,
      email,
    } = this.state

    const {
      submit,
      onCancel,
      onSuccess,
    } = this.props

    submit({ organizationId, email })
    .then(() => {
      onCancel()
      onSuccess()
    })
    .catch(error => this.setState({ mutationError: error.message }))
  }

  render () {
    const {
      organizationId,
      mutationError,
    } = this.state

    const { onCancel } = this.props

    return (
      <div>
        { mutationError && <Notifications.Error message={mutationError} />}
        <h3>An email will be sent to the new user to complete the registration process.</h3>
        <Grid.Row>
          <Grid.Col><h3>NEW MANAGER:</h3></Grid.Col>
          <Grid.Col width={4}>
            <Form.Text
              label={'Email'}
              value={this.state.email}
              onChange={this.handleEmailChange}
            />
          </Grid.Col>
        </Grid.Row>
        <div>
          <Grid.Row>
            <h3>ORGANIZATION:</h3>
          </Grid.Row>
          <Grid.Row>
            <Grid.Col>
              Company
              <UserOrganizationList onChange={this.handleOrgSelect} />
            </Grid.Col>
            <Grid.Col>
              Buildings
              { organizationId &&
                <UserBuildingList organizationId={organizationId} />
              }
            </Grid.Col>
            <Grid.Col>
              <Form.Actions>
                <Form.Button onClick={onCancel}>
                  Cancel
                </Form.Button>
                <Form.Button onClick={this.handleSubmit}>
                  Save
                </Form.Button>
              </Form.Actions>
            </Grid.Col>
          </Grid.Row>
        </div>
      </div>
    )
  }
}

AdminUserCreate.propTypes = {
  onSuccess: t.func.isRequired,
  onCancel: t.func.isRequired,
}

const AdminUserCreateMutation = gql`
  mutation AdminUserCreateMutation(
    $organizationId: Int!,
    $email: String!
  ) {
    createManager(
      organizationId: $organizationId,
      email: $email
    ) {
      id
    }
  }
`

export default graphql(AdminUserCreateMutation, {
  props: ({ mutate }) => ({
    submit: (variables) => mutate({ variables }),
  }),
})(AdminUserCreate)



// WEBPACK FOOTER //
// ./src/components/Profile/AdminUserCreate.jsx